import { useEffect } from 'react'
import {
  holidayData,
  kepkoTou,
  seasonMapping,
  touPeriods,
} from '../util/algorithm/fakeRatesData'
import { timeData } from '../util/algorithm/fakeLoadData'
import {
  calLoadTimeSum,
  multiplyValuesByRealTime,
  multiplyValuesByTime,
} from '../util/algorithm/classifyTimeData'

import { calKepcoAverage } from '../util/algorithm/kepcoTOU'
import { calSmpTimeRate } from '../util/algorithm/smp'
import { calMinChargeUnit, calTouUnitCharge } from '../util/algorithm/makeTOU'
import {
  calSeasonalSum,
  monthLoadTimeToSeasonLoadTime,
} from '../util/algorithm/monthToSeason'
import { calMonthCharge } from '../util/algorithm/calCharge'
import { calSeasonalExCharge } from '../util/algorithm/calExCharge'
import { calMonthRepPattern } from '../util/algorithm/calRepPattern'

const AlgoTest = () => {
  useEffect(() => {
    //---------------머지테스트용 커밋
    const tmpSeasonMapping = seasonMapping
    // 1. PV 고르기
    // 원본 데이터일 경우
    const pvData = timeData

    // 평균값일 경우
    const monthRepPattern = calMonthRepPattern(timeData, 'aver')
    console.log('평균', monthRepPattern.repData)
    console.log('평균 그래프용', monthRepPattern.graphData)

    // 계절별 전력거래 합 구하기
    const seasonalPVSum = calSeasonalSum(pvData, tmpSeasonMapping)
    console.log('계절별 전력거래 합', seasonalPVSum)
    //---------------
    // 2-1. 전력시장 수수료 단가 고르면 계절별로 계산
    const seasonalTradingCharge = calSeasonalExCharge(0.1034, seasonalPVSum)
    console.log('전력시장 거래 수수료 단가', seasonalTradingCharge)

    // 2-2. 한전 요금제 고르면 요금제 비율 평균 가져오기 (여기서는 일단 계산)
    const kepcoTOUList = [kepkoTou]
    const kepcoTouAverRate = calKepcoAverage(kepcoTOUList)
    console.log('한전요금제 평균', kepcoTouAverRate)

    // 2-3. 현물 REC 고르면 불러오기
    const REC = timeData

    // 2-4. SMP 연도 고르기
    const SMP = timeData

    // 2-5 공휴일 고르기
    const tmpHolidayData = holidayData

    // smp로 비율이랑 시간대 계산
    const smpValues = calSmpTimeRate(SMP, seasonMapping, holidayData)

    console.log('SMP로 구한 시간대', smpValues.smpTimePeriod)
    console.log('SMP로 구한 비율', smpValues.smpRate)

    //---------------
    // 수익계산에 사용될 smp 고르기
    // 기존 수익 계산

    // 1. 실시간 SMP 일 경우
    const mul = multiplyValuesByRealTime(pvData, SMP)
    console.log('pvData', pvData)

    console.log('mul', mul)

    // 2. 최소/최대/가중평균 SMP 일 경우
    //TODO: 테스트 예정
    const mul1 = multiplyValuesByTime(pvData, SMP)
    console.log('mul1', mul1)

    //------------------
    //시간대 설정
    //1. 한전 TOU 요금제일 경우
    let touPeriod = touPeriods
    //2. smp로 산정
    touPeriod = smpValues.smpTimePeriod

    console.log('시간대', touPeriod)

    //정해진 시간대로 월별 최소/중간/최대 발전량 계산하기
    const monthlyTimePeriodGen = calLoadTimeSum(
      pvData,
      seasonMapping,
      holidayData,
      touPeriod
    ).loadTimeSumResult

    // 월별 발전량> 계절별 발전량
    const seasonalTimePeriodGen = monthLoadTimeToSeasonLoadTime(
      monthlyTimePeriodGen,
      seasonMapping
    )

    console.log('계절별 발전량 ', seasonalTimePeriodGen)

    //3.단일시간대

    // ----------------
    // 가격비율 설정
    // 1. 한전 요금제 비율일 경우
    let touRate = kepcoTouAverRate

    // 2. smp 로 산정
    touRate = smpValues.smpRate

    console.log('가격비율', touRate)

    // ------------------
    // 추가 수익 설정
    const addEarnings = {
      spr: 100000,
      sum: 100000,
      fall: 100000,
      win: 100000,
    }
    // -------------

    // 1) 수익이랑 시간대 넣고 계절별 기존 수익 계산하기
    const monthProfit = calSeasonalSum(mul, seasonMapping)

    // 2) 추가 수익이랑 기존 수익 더하기
    monthProfit.spr += addEarnings.spr
    monthProfit.sum += addEarnings.sum
    monthProfit.fall += addEarnings.fall
    monthProfit.win += addEarnings.win

    console.log('계절별 수익', monthProfit)

    // 3) 계절별 최소요금단가 계산하기 calMinChargeUnit
    const seasonalMinChargeUnit = calMinChargeUnit(
      touRate,
      seasonalTimePeriodGen,
      monthProfit
    )

    console.log('최소요금 단가', seasonalMinChargeUnit)
    // 4) 단가랑 비율로 요금제 단가 계산하기 calTouUnitCharge
    const touUnit = calTouUnitCharge(touRate, seasonalMinChargeUnit)

    console.log('요금제 단가', touUnit)

    //------
    // 변경 후 요금 계산하기
    const afterCharge = monthLoadTimeToSeasonLoadTime(
      calMonthCharge(monthlyTimePeriodGen, touUnit, seasonMapping),
      seasonMapping
    )
    console.log('이후 요금', afterCharge)
    console.log(
      '봄',
      afterCharge.spr.min + afterCharge.spr.mid + afterCharge.spr.max
    )
  }, [])
  return <div></div>
}

export default AlgoTest
